const initialState = {
  count: 0,
  results: [],
};

const accountReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'ACCOUNT_GET_DONE':
      return { ...action.payload };
    default:
      return state;
  }
};

export default accountReducer;
